import { render } from "./PagerList.vue?vue&type=template&id=7afbd855"
import script from "./PagerList.vue?vue&type=script&lang=js"
export * from "./PagerList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__